import * as React from "react";
import {
  Card,
  Grid,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  FormGroup,
  Divider,
  Box,
  Typography,
  Paper,
  Button,
  IconButton,
  FormHelperText,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText
} from "@mui/material";
import { CloudUpload, Delete, Save } from "@mui/icons-material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { POST, GET, PUT } from "APIclient";
import { Snackbar, Alert } from "@mui/material";
import properties from "constants/ApplicationConstants";
import { useLocation, useNavigate } from "react-router-dom";

const consistentTextStyle = {
  "& .MuiInputBase-input": { color: "black !important" },
  "& .MuiInputLabel-root": { color: "black !important" },
  "& .Mui-disabled": {
    WebkitTextFillColor: "black !important",
    color: "black !important",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": { borderColor: "rgba(0, 0, 0, 0.23)" },
  },
};

export default function ExitInterviewForm() {
  const dateOfLeaving = localStorage.getItem('resignationEndDate') || '';
  const dateOfJoining = localStorage.getItem("joiningDate") || '';
  const employeeName = localStorage.getItem('EmpName') || '';
  const designation = localStorage.getItem('currentDesignation') || '';
  const reportingManagerName = localStorage.getItem("reportingManagerName") || '';
  const getUserType = () => {
    const raw = localStorage.getItem("userType");
    if (!raw) return "";
    try {
      return JSON.parse(raw);
    } catch (e) {
      return raw.trim();
    }
  };

  const userRole = getUserType();
  const isAdmin = userRole === "Admin";

  console.log("userRole:", userRole);
  console.log("isAdmin:", isAdmin);

  const location = useLocation();
  const navigate = useNavigate();
  const mode = location.state?.mode || "edit";
  const resignationId = location.state?.resignationId;
  const employeeId = location.state?.employeeId;
  const empId = isAdmin ? employeeId : window.sessionStorage.getItem("empId");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [snackColor, setSnackColor] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState("");

  const [existingFormId, setExistingFormId] = React.useState(null);
  const [isUpdate, setIsUpdate] = React.useState(false);

  const [signatures, setSignatures] = React.useState({
    employee: null,
    interviewer: null
  });

  const [errors, setErrors] = React.useState({});
  const [touched, setTouched] = React.useState({});



  // Confirmation Dialog State
  const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(false);

  // Status field: DRAFT, SUBMITTED_BY_EMPLOYEE, SUBMITTED_BY_ADMIN
  const [formStatus, setFormStatus] = React.useState("DRAFT");

  const [formData, setFormData] = React.useState({
    employeeName: employeeName || "",
    empId: empId || "",
    designation: designation || "",
    project: "",
    projectManager: reportingManagerName || "",
    dateOfJoining: dateOfJoining ? dayjs(dateOfJoining) : null,
    dateOfLeaving: dateOfLeaving ? dayjs(dateOfLeaving) : null,
    methodOfLeaving: "",
    reasonsForLeaving: "",
    mostSatisfying: "",
    mostDissatisfying: "",
    companyCouldHaveDone: "",
    compensationAndBenefits: false,
    opportunityForAdvancement: false,
    moreDesirableLocation: false,
    moreResponsibility: false,
    opportunityForGoodProjects: false,
    workingForBigName: false,
    moreJobFlexibility: false,
    otherReasons: "",
    showOtherText: false,
    suggestionsForPosition: "",
    positionCompatibility: "",
    possibilityForAdvancement: "",
    trainingDevelopmentNeeded: "",
    greatestChallenge: "",
    wouldRecommendBNT: "",
    suggestionsForImprovement: "",
    interviewDate: dayjs()
  });

  // Determine if form is editable based on role and status
  const getEditableState = () => {
    if (mode === "view") return { formEditable: false, employeeSignEditable: false, interviewerSignEditable: false };

    if (isAdmin) {
      // Admin can only edit interviewer signature when status is SUBMITTED_BY_EMPLOYEE
      return {
        formEditable: false,
        employeeSignEditable: false,
        interviewerSignEditable: formStatus === "SUBMITTED_BY_EMPLOYEE" || formStatus === "SUBMITTED_BY_EMPLOYE"
      };
    } else {
      // Employee can edit form and sign only when status is DRAFT
      return {
        formEditable: formStatus === "DRAFT",
        employeeSignEditable: formStatus === "DRAFT",
        interviewerSignEditable: false
      };
    }
  };

  const { formEditable, employeeSignEditable, interviewerSignEditable } = getEditableState();

  React.useEffect(() => {
    if (empId && mode !== "view") {
      fetchExitInterviewData();
    } else if (resignationId && mode === "view") {
      fetchExitInterviewData();
    }
  }, [empId, resignationId, mode]);

  const convertToDataURL = (base64String) => {
    if (!base64String) return null;
    if (base64String.startsWith('data:')) return base64String;

    // Check if it's a PDF by looking at the magic bytes (JVBERi0 is the base64 of "%PDF-")
    if (base64String.startsWith('JVBER')) {
      return `data:application/pdf;base64,${base64String}`;
    }

    // Default to image/png for other base64 strings
    return `data:image/png;base64,${base64String}`;
  };

  const fetchExitInterviewData = async () => {
    try {
      const url = `api/exit/interview?employeeId=${empId}`;
      const response = await GET(url);

      if (response.status === 200 && response.data) {
        const dataArray = response?.data?.data?.paginatedData || [];

        if (dataArray.length === 0) {
          console.log("No existing exit interview found. Creating new one.");
          setIsUpdate(false);
          setExistingFormId(null);
          return;
        }

        const data = dataArray[0];

        setIsUpdate(true);
        setExistingFormId(data.exitInterviewId);

        // Set form status from backend (DRAFT, SUBMITTED_BY_EMPLOYEE, SUBMITTED_BY_ADMIN)
        setFormStatus(data.status || "DRAFT");

        setFormData({
          ...formData,
          employeeName: data.employeeName || "",
          designation: data.designation || "",
          project: data.project || "",
          projectManager: data.projectManager || "",
          dateOfJoining: data.dateOfJoining ? dayjs(data.dateOfJoining) : null,
          dateOfLeaving: data.dateOfLeaving ? dayjs(data.dateOfLeaving) : null,
          methodOfLeaving: data.methodOfLeaving || "",
          reasonsForLeaving: data.reasonsForLeaving || "",
          mostSatisfying: data.mostSatisfying || "",
          mostDissatisfying: data.mostDissatisfying || "",
          companyCouldHaveDone: data.companyCouldHaveDone || "",
          compensationAndBenefits: data.compensationAndBenefits || false,
          opportunityForAdvancement: data.opportunityForAdvancement || false,
          moreDesirableLocation: data.moreDesirableLocation || false,
          moreResponsibility: data.moreResponsibility || false,
          opportunityForGoodProjects: data.opportunityForGoodProjects || false,
          workingForBigName: data.workingForBigName || false,
          moreJobFlexibility: data.moreJobFlexibility || false,
          otherReasons: data.otherReasons || "",
          showOtherText: !!data.otherReasons,
          suggestionsForPosition: data.suggestionsForPosition || "",
          positionCompatibility: data.positionCompatibility || "",
          possibilityForAdvancement: data.possibilityForAdvancement || "",
          trainingDevelopmentNeeded: data.trainingDevelopmentNeeded || "",
          greatestChallenge: data.greatestChallenge || "",
          wouldRecommendBNT: data.wouldRecommendBNT || "",
          suggestionsForImprovement: data.suggestionsForImprovement || "",
          interviewDate: data.interviewDate ? dayjs(data.interviewDate) : dayjs()
        });

        setSignatures({
          employee: convertToDataURL(data.employeeSignature),
          interviewer: convertToDataURL(data.interviewerSignature)
        });
      }
    } catch (error) {
      if (error.response?.status === 404) {
        console.log("No existing exit interview found. Creating new one.");
        setIsUpdate(false);
        setExistingFormId(null);
      } else {
        console.error("Error fetching exit interview data:", error);
        setSnackMessage(error.response?.data?.message || "Failed to load exit interview data");
        setSnackColor("error");
        setSnackOpen(true);
      }
    }
  };

  const validateTextAnswer = (value) => {
    if (!value || value.trim() === "") {
      return "This field is required";
    }

    const trimmedValue = value.trim();

    if (/^[\s\.\,\!\@\#\$\%\^\&\*\(\)\-\+\=\[\]\{\}\;\:\'\"\<\>\?\/\\|`~]+$/.test(trimmedValue)) {
      return "Please provide a meaningful answer, not just spaces or symbols";
    }

    if (trimmedValue.length < 10) {
      return "Please provide a detailed answer (minimum 10 characters)";
    }

    if (trimmedValue.length > 1000) {
      return "Answer should not exceed 1000 characters";
    }

    return "";
  };

  const validateField = (field, value) => {
    let error = "";

    switch (field) {
      case "employeeName":
        if (!value || value.trim() === "") {
          error = "Employee name is required";
        }
        break;
      case "designation":
        if (!value || value.trim() === "") {
          error = "Designation is required";
        }
        break;
      case "project":
        if (!value || value.trim() === "") {
          error = "Project name is required";
        }
        break;
      case "projectManager":
        if (!value || value.trim() === "") {
          error = "Project manager name is required";
        }
        break;
      case "dateOfJoining":
        if (!value) {
          error = "Date of joining is required";
        }
        break;
      case "dateOfLeaving":
        if (!value) {
          error = "Date of leaving is required";
        }
        break;
      case "methodOfLeaving":
        if (!value) {
          error = "Please select a method of leaving";
        }
        break;
      case "reasonsForLeaving":
      case "mostSatisfying":
      case "mostDissatisfying":
      case "companyCouldHaveDone":
      case "suggestionsForPosition":
      case "positionCompatibility":
      case "possibilityForAdvancement":
      case "trainingDevelopmentNeeded":
      case "greatestChallenge":
      case "wouldRecommendBNT":
      case "suggestionsForImprovement":
        error = validateTextAnswer(value);
        break;
      case "otherReasons":
        if (formData.showOtherText) {
          error = validateTextAnswer(value);
        }
        break;
      case "interviewDate":
        if (!value) {
          error = "Interview date is required";
        }
        break;
      case "employeeSignature":
        if (!signatures.employee && !isAdmin) {
          error = "Employee signature is required";
        }
        break;
      case "interviewerSignature":
        if (!signatures.interviewer && isAdmin) {
          error = "Interviewer signature is required";
        }
        break;
      default:
        break;
    }

    return error;
  };

  const validateForm = () => {
    const newErrors = {};

    // For employee submitting
    if (!isAdmin) {
      const fieldsToValidate = [
        "employeeName",
        "designation",
        "project",
        "projectManager",
        "dateOfJoining",
        "dateOfLeaving",
        "methodOfLeaving",
        "reasonsForLeaving",
        "mostSatisfying",
        "mostDissatisfying",
        "companyCouldHaveDone",
        "suggestionsForPosition",
        "positionCompatibility",
        "possibilityForAdvancement",
        "trainingDevelopmentNeeded",
        "greatestChallenge",
        "wouldRecommendBNT",
        "suggestionsForImprovement",
        "interviewDate"
      ];

      fieldsToValidate.forEach(field => {
        const error = validateField(field, formData[field]);
        if (error) {
          newErrors[field] = error;
        }
      });

      if (formData.showOtherText) {
        const otherError = validateField("otherReasons", formData.otherReasons);
        if (otherError) {
          newErrors.otherReasons = otherError;
        }
      }

      if (!signatures.employee) {
        newErrors.employeeSignature = "Employee signature is required";
      }
    }

    // For admin submitting (only interviewer signature required)
    if (isAdmin) {
      if (!signatures.interviewer) {
        newErrors.interviewerSignature = "Interviewer signature is required";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));

    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ""
      }));
    }

    if (touched[field]) {
      const error = validateField(field, value);
      setErrors(prev => ({
        ...prev,
        [field]: error
      }));
    }
  };

  const handleBlur = (field) => {
    setTouched(prev => ({
      ...prev,
      [field]: true
    }));

    const error = validateField(field, formData[field]);
    setErrors(prev => ({
      ...prev,
      [field]: error
    }));
  };

  const handleSignatureUpload = (section, event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        setSnackMessage('File size should not exceed 2MB');
        setSnackColor('error');
        setSnackOpen(true);
        return;
      }

      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
      if (!allowedTypes.includes(file.type)) {
        setSnackMessage('Only JPEG, JPG, PNG, and PDF files are allowed');
        setSnackColor('error');
        setSnackOpen(true);
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setSignatures(prev => ({ ...prev, [section]: reader.result }));
        setErrors(prev => ({
          ...prev,
          [`${section}Signature`]: ""
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSignatureRemove = (section) => {
    setSignatures(prev => ({ ...prev, [section]: null }));
    setErrors(prev => ({
      ...prev,
      [`${section}Signature`]: `${section === 'employee' ? 'Employee' : 'Interviewer'} signature is required`
    }));
  };

  // Save as Draft - Only for employees, only when status is DRAFT
  const handleSaveAsDraft = async () => {
    if (isAdmin) {
      setSnackMessage("Admin cannot save draft");
      setSnackColor("error");
      setSnackOpen(true);
      return;
    }

    if (formStatus !== "DRAFT") {
      setSnackMessage("Cannot save draft - form has already been submitted");
      setSnackColor("error");
      setSnackOpen(true);
      return;
    }

    try {
      const submitData = {
        employeeId: empId,
        employeeName: formData.employeeName,
        designation: formData.designation,
        project: formData.project,
        projectManager: formData.projectManager,
        dateOfJoining: formData.dateOfJoining ? formData.dateOfJoining.format("YYYY-MM-DD") : null,
        dateOfLeaving: formData.dateOfLeaving ? formData.dateOfLeaving.format("YYYY-MM-DD") : null,
        methodOfLeaving: formData.methodOfLeaving,
        reasonsForLeaving: formData.reasonsForLeaving,
        mostSatisfying: formData.mostSatisfying,
        mostDissatisfying: formData.mostDissatisfying,
        companyCouldHaveDone: formData.companyCouldHaveDone,
        compensationAndBenefits: formData.compensationAndBenefits,
        opportunityForAdvancement: formData.opportunityForAdvancement,
        moreDesirableLocation: formData.moreDesirableLocation,
        moreResponsibility: formData.moreResponsibility,
        opportunityForGoodProjects: formData.opportunityForGoodProjects,
        workingForBigName: formData.workingForBigName,
        moreJobFlexibility: formData.moreJobFlexibility,
        otherReasons: formData.showOtherText ? formData.otherReasons : null,
        suggestionsForPosition: formData.suggestionsForPosition,
        positionCompatibility: formData.positionCompatibility,
        possibilityForAdvancement: formData.possibilityForAdvancement,
        trainingDevelopmentNeeded: formData.trainingDevelopmentNeeded,
        greatestChallenge: formData.greatestChallenge,
        wouldRecommendBNT: formData.wouldRecommendBNT,
        suggestionsForImprovement: formData.suggestionsForImprovement,
        interviewDate: formData.interviewDate ? formData.interviewDate.format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD"),
        employeeSignature: signatures.employee || null,
        interviewerSignature: signatures.interviewer || null,
        status: "DRAFT"
      };

      const response = isUpdate
        ? await PUT(`api/exit/interview/${empId}`, submitData)
        : await POST(`api/exit/interview/submit`, submitData);

      if (response.status === 200 || response.status === 201) {
        setSnackMessage("Form saved as draft successfully!");
        setSnackColor("success");
        setSnackOpen(true);
        fetchExitInterviewData();
      }
    } catch (error) {
      setSnackMessage("Failed to save draft. Please try again.");
      setSnackColor("error");
      setSnackOpen(true);
    }
  };

  // Final Submit
  const handleFinalSubmit = async () => {
    setConfirmDialogOpen(false);

    if (!validateForm()) {
      setSnackMessage("Please fill in all required fields correctly");
      setSnackColor("error");
      setSnackOpen(true);

      const firstErrorField = document.querySelector('[aria-invalid="true"]');
      if (firstErrorField) {
        firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    try {
      const submitData = {
        employeeId: empId,
        employeeName: formData.employeeName,
        designation: formData.designation,
        project: formData.project,
        projectManager: formData.projectManager,
        dateOfJoining: formData.dateOfJoining ? formData.dateOfJoining.format("YYYY-MM-DD") : null,
        dateOfLeaving: formData.dateOfLeaving ? formData.dateOfLeaving.format("YYYY-MM-DD") : null,
        methodOfLeaving: formData.methodOfLeaving,
        reasonsForLeaving: formData.reasonsForLeaving,
        mostSatisfying: formData.mostSatisfying,
        mostDissatisfying: formData.mostDissatisfying,
        companyCouldHaveDone: formData.companyCouldHaveDone,
        compensationAndBenefits: formData.compensationAndBenefits,
        opportunityForAdvancement: formData.opportunityForAdvancement,
        moreDesirableLocation: formData.moreDesirableLocation,
        moreResponsibility: formData.moreResponsibility,
        opportunityForGoodProjects: formData.opportunityForGoodProjects,
        workingForBigName: formData.workingForBigName,
        moreJobFlexibility: formData.moreJobFlexibility,
        otherReasons: formData.showOtherText ? formData.otherReasons : null,
        suggestionsForPosition: formData.suggestionsForPosition,
        positionCompatibility: formData.positionCompatibility,
        possibilityForAdvancement: formData.possibilityForAdvancement,
        trainingDevelopmentNeeded: formData.trainingDevelopmentNeeded,
        greatestChallenge: formData.greatestChallenge,
        wouldRecommendBNT: formData.wouldRecommendBNT,
        suggestionsForImprovement: formData.suggestionsForImprovement,
        interviewDate: formData.interviewDate ? formData.interviewDate.format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD"),
        employeeSignature: signatures.employee || null,
        interviewerSignature: signatures.interviewer || null,
        status: isAdmin ? "SUBMITTED_BY_ADMIN" : "SUBMITTED_BY_EMPLOYEE"
      };

      const response = isUpdate
        ? await PUT(`api/exit/interview/${empId}`, submitData)
        : await POST(`api/exit/interview/submit`, submitData);

      if (response.status === 200 || response.status === 201) {
        setSnackMessage(isAdmin ? "Interviewer signature submitted successfully!" : "Exit interview form submitted successfully!");
        setSnackColor("success");
        setSnackOpen(true);

        setFormStatus(isAdmin ? "SUBMITTED_BY_ADMIN" : "SUBMITTED_BY_EMPLOYEE");

        setTimeout(() => {
          navigate(isAdmin ? "/exitInterviewList" : "/resignation");
        }, 2000);
      }
    } catch (error) {
      console.error("Submit error:", error);
      setSnackMessage(error.response?.data?.message || "Failed to submit exit interview form.");
      setSnackColor("error");
      setSnackOpen(true);
    }
  };

  const handleSubmitClick = (e) => {
    e.preventDefault();
    setConfirmDialogOpen(true);
  };

  const handleClose = () => {
    setSnackOpen(false);
  };

  const getStatusChip = () => {
    switch (formStatus) {
      case "DRAFT":
        return <Chip label="Draft" color="default" size="small" />;
      case "SUBMITTED_BY_EMPLOYEE":
      case "SUBMITTED_BY_EMPLOYE": // Handle both spellings
        return <Chip label="Awaiting Interviewer Signature" color="warning" size="small" />;
      case "SUBMITTED_BY_ADMIN":
        return <Chip label="Completed" color="success" size="small" />;
      default:
        return null;
    }
  };

  const SignatureUpload = ({ section, label }) => {
    const isEmployeeSection = section === "employee";
    const isInterviewerSection = section === "interviewer";
    const canEdit = isEmployeeSection ? employeeSignEditable : interviewerSignEditable;
    const hasSignature = !!signatures[section];
    const signatureUrl = signatures[section];

    // Helper to detect PDF reliably
    const isPdf = signatureUrl
      ? signatureUrl.includes('application/pdf') || signatureUrl.startsWith('data:application/pdf')
      : false;

    // 1. Non-admin viewing interviewer section → show only status
    if (isInterviewerSection && !isAdmin) {
      return (
        <Box sx={{ mt: 0 }}>
          <Typography variant="body2" fontWeight="medium" mb={1}>
            {label}
          </Typography>
          <Chip
            label={formStatus === "SUBMITTED_BY_ADMIN" ? "Completed" : "Pending"}
            color={formStatus === "SUBMITTED_BY_ADMIN" ? "success" : "warning"}
            size="small"
          />
        </Box>
      );
    }

    // 2. Admin viewing employee section → read-only signature (no upload button)
    if (isEmployeeSection && isAdmin) {
      return (
        <Box sx={{ mt: 0 }}>
          <Typography variant="body2" fontWeight="medium" mb={1}>
            {label}
          </Typography>
          {hasSignature ? (
            <Box sx={{ position: "relative", display: "inline-block" }}>
              {isPdf ? (
                <Box
                  sx={{
                    width: 200,
                    height: 100,
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "#f9f9f9",
                  }}
                >
                  <embed
                    src={`${signatureUrl}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
                    type="application/pdf"
                    width="200"
                    height="100"
                    style={{ display: "block", border: "none" }}
                  />
                </Box>
              ) : (
                <img
                  src={signatureUrl}
                  alt={label}
                  style={{
                    maxWidth: "200px",
                    maxHeight: "100px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                  }}
                />
              )}
            </Box>
          ) : (
            <Typography variant="body2" color="text.secondary">
              No signature uploaded
            </Typography>
          )}
        </Box>
      );
    }

    // 3. Editable cases:
    //    - Employee editing their own signature
    //    - Admin editing interviewer signature
    return (
      <Box sx={{ mt: 0 }}>
        <Typography variant="body2" fontWeight="medium" mb={1}>
          {label} <span style={{ color: "red" }}>*</span>
        </Typography>
        <Typography variant="caption" color="text.secondary" display="block" mb={1}>
          Allowed formats: JPEG, JPG, PNG, PDF (Max size: 2MB)
        </Typography>

        {hasSignature ? (
          <Box sx={{ position: "relative", display: "inline-block" }}>
            {isPdf ? (
              <Box
                sx={{
                  width: 200,
                  height: 100,
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  overflow: "hidden",
                  "& embed": {
                    overflow: "hidden",
                  }
                }}
              >
                <embed
                  src={`${signatureUrl}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
                  type="application/pdf"
                  width="200"
                  height="100"
                  style={{ display: "block", border: "none" }}
                />
              </Box>
            ) : (
              <img
                src={signatureUrl}
                alt={label}
                style={{
                  maxWidth: "200px",
                  maxHeight: "100px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                }}
              />
            )}
            {/* Only show delete button if user can edit */}
            {canEdit && (
              <IconButton
                size="small"
                onClick={() => handleSignatureRemove(section)}
                sx={{
                  position: "absolute",
                  top: -10,
                  right: -10,
                  bgcolor: "background.paper",
                  boxShadow: 1,
                  "&:hover": { bgcolor: "error.light" },
                }}
              >
                <Delete fontSize="small" color="error" />
              </IconButton>
            )}
          </Box>
        ) : (
          /* Show upload button only if editable */
          canEdit && (
            <Button
              variant="outlined"
              component="label"
              startIcon={<CloudUpload />}
              size="small"
              sx={{
                borderStyle: "dashed",
                color: "primary.main",
              }}
            >
              Upload Signature
              <input
                type="file"
                hidden
                accept=".jpeg,.jpg,.png,.pdf,image/jpeg,image/jpg,image/png,application/pdf"
                onChange={(e) => handleSignatureUpload(section, e)}
              />
            </Button>
          )
        )}

        {errors[`${section}Signature`] && (
          <FormHelperText error sx={{ mt: 1 }}>
            {errors[`${section}Signature`]}
          </FormHelperText>
        )}
      </Box>
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={3} mb={3}>
        <Card>
          <MDBox p={3}>
            {/* Header */}
            <MDBox mb={3} textAlign="center">
              <MDTypography
                variant="h4"
                fontWeight="bold"
                sx={{
                  fontFamily: properties.fontFamily,
                  textDecoration: "underline",
                  mb: 2
                }}
              >
                EXIT INTERVIEW FORM
              </MDTypography>
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                {/* {getStatusChip()} */}
              </Box>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                This questionnaire is designed to improvise the work culture and organizational
                environment prevailing in BNT. Your sincere response will help us in making the
                work culture more satisfying and fulfilling for our associates. All answers will be
                held in strict confidence. Thank you.
              </Typography>
            </MDBox>

            <form onSubmit={handleSubmitClick}>
              {/* Employee Details Section */}
              <Paper elevation={0} sx={{ p: 2, mb: 3, bgcolor: "#f5f5f5" }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <TextField
                      fullWidth
                      label="Name"
                      value={formData.employeeName}
                      variant="outlined"
                      size="small"
                      disabled
                      InputProps={{ readOnly: true }}
                      sx={consistentTextStyle}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      fullWidth
                      label="Employee ID"
                      value={formData.empId}
                      variant="outlined"
                      size="small"
                      disabled
                      InputProps={{ readOnly: true }}
                      sx={consistentTextStyle}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      fullWidth
                      label="Designation"
                      value={formData.designation}
                      variant="outlined"
                      size="small"
                      disabled
                      InputProps={{ readOnly: true }}
                      sx={consistentTextStyle}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      fullWidth
                      label="Project"
                      value={formData.project}
                      onChange={(e) => handleInputChange("project", e.target.value)}
                      onBlur={() => handleBlur("project")}
                      variant="outlined"
                      size="small"
                      disabled={!formEditable}
                      error={!!errors.project}
                      helperText={errors.project}
                      required
                      sx={consistentTextStyle}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      fullWidth
                      label="Reporting Manager"
                      value={formData.projectManager}
                      // onChange={(e) => handleInputChange("projectManager", e.target.value)}
                      onBlur={() => handleBlur("projectManager")}
                      variant="outlined"
                      size="small"
                      disabled
                      InputProps={{ readOnly: true }}
                      error={!!errors.projectManager}
                      helperText={errors.projectManager}
                      required
                      sx={consistentTextStyle}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="DOJ (Date of Joining)"
                        value={formData.dateOfJoining}
                        disabled
                        readOnly
                        format="DD/MM/YYYY"
                        slotProps={{
                          textField: {
                            size: "small",
                            fullWidth: true,
                            sx: {
                              "& .MuiInputBase-input": { color: "black !important" },
                              "& .MuiInputLabel-root": { color: "black !important" },
                              "& .Mui-disabled": {
                                WebkitTextFillColor: "black !important",
                                color: "black !important",
                              },
                            },
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="DOL (Date of Leaving)"
                        value={formData.dateOfLeaving}
                        disabled
                        readOnly
                        format="DD/MM/YYYY"
                        slotProps={{
                          textField: {
                            size: "small",
                            fullWidth: true,
                            sx: {
                              "& .MuiInputBase-input": { color: "black !important" },
                              "& .MuiInputLabel-root": { color: "black !important" },
                              "& .Mui-disabled": {
                                WebkitTextFillColor: "black !important",
                                color: "black !important",
                              },
                            },
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </Paper>

              <Divider sx={{ my: 3 }} />

              {/* All form questions... continuing with Question 1 through 13 */}
              <MDBox mb={3}>
                <FormControl component="fieldset" error={!!errors.methodOfLeaving}>
                  <FormLabel component="legend" sx={{
                    fontWeight: "bold",
                    color: "#000 !important",  // Add !important to override error state
                    mb: 1,
                    "& .MuiFormLabel-asterisk": { color: "red" },
                    "&.Mui-error": {
                      color: "#000 !important"  // Keep black even in error state
                    }
                  }} required>
                    1. Method of leaving the organization.
                  </FormLabel>
                  <RadioGroup
                    value={formData.methodOfLeaving}
                    onChange={(e) => handleInputChange("methodOfLeaving", e.target.value)}
                    onBlur={() => handleBlur("methodOfLeaving")}
                  >
                    <FormControlLabel
                      value="RESIGNATION"
                      control={<Radio />}
                      label="Resignation"
                      disabled={!formEditable}
                    />
                    <FormControlLabel
                      value="TERMINATION"
                      control={<Radio />}
                      label="Termination"
                      disabled={!formEditable}
                    />
                  </RadioGroup>
                  {errors.methodOfLeaving && (
                    <FormHelperText>{errors.methodOfLeaving}</FormHelperText>
                  )}
                </FormControl>
              </MDBox>

              {/* Questions 2-13 with same pattern */}
              <MDBox mb={3}>
                <FormLabel component="legend" sx={{ fontWeight: "bold", color: "#000", mb: 1, "& .MuiFormLabel-asterisk": { color: "red" } }} required>
                  2. What are your primary reasons for leaving BNT SOFT?
                </FormLabel>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={formData.reasonsForLeaving}
                  onChange={(e) => handleInputChange("reasonsForLeaving", e.target.value)}
                  onBlur={() => handleBlur("reasonsForLeaving")}
                  variant="outlined"
                  disabled={!formEditable}
                  error={!!errors.reasonsForLeaving}
                  helperText={errors.reasonsForLeaving || `${formData.reasonsForLeaving.length}/1000 characters`}
                  placeholder="Please provide detailed reasons for your decision to leave (10-1000 characters)"
                  inputProps={{ maxLength: 1000 }}
                  sx={consistentTextStyle}
                />
              </MDBox>

              <MDBox mb={3}>
                <FormLabel component="legend" sx={{ fontWeight: "bold", color: "#000", mb: 1, "& .MuiFormLabel-asterisk": { color: "red" } }} required>
                  3. What did you find most satisfying about your job?
                </FormLabel>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={formData.mostSatisfying}
                  onChange={(e) => handleInputChange("mostSatisfying", e.target.value)}
                  onBlur={() => handleBlur("mostSatisfying")}
                  variant="outlined"
                  disabled={!formEditable}
                  error={!!errors.mostSatisfying}
                  helperText={errors.mostSatisfying || `${formData.mostSatisfying.length}/1000 characters`}
                  placeholder="Share the aspects of your job that you found most fulfilling (10-1000 characters)"
                  inputProps={{ maxLength: 1000 }}
                  sx={consistentTextStyle}
                />
              </MDBox>

              <MDBox mb={3}>
                <FormLabel component="legend" sx={{ fontWeight: "bold", color: "#000", mb: 1, "& .MuiFormLabel-asterisk": { color: "red" } }} required>
                  4. What did you find most dissatisfying about your job?
                </FormLabel>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={formData.mostDissatisfying}
                  onChange={(e) => handleInputChange("mostDissatisfying", e.target.value)}
                  onBlur={() => handleBlur("mostDissatisfying")}
                  variant="outlined"
                  disabled={!formEditable}
                  error={!!errors.mostDissatisfying}
                  helperText={errors.mostDissatisfying || `${formData.mostDissatisfying.length}/1000 characters`}
                  placeholder="Please share any challenges or concerns you experienced (10-1000 characters)"
                  inputProps={{ maxLength: 1000 }}
                  sx={consistentTextStyle}
                />
              </MDBox>

              <MDBox mb={3}>
                <FormLabel component="legend" sx={{ fontWeight: "bold", color: "#000", mb: 1, "& .MuiFormLabel-asterisk": { color: "red" } }} required>
                  5. Is there anything the company could have done to prevent you from leaving?
                </FormLabel>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={formData.companyCouldHaveDone}
                  onChange={(e) => handleInputChange("companyCouldHaveDone", e.target.value)}
                  onBlur={() => handleBlur("companyCouldHaveDone")}
                  variant="outlined"
                  disabled={!formEditable}
                  error={!!errors.companyCouldHaveDone}
                  helperText={errors.companyCouldHaveDone || `${formData.companyCouldHaveDone.length}/1000 characters`}
                  placeholder="Your honest feedback will help us improve (10-1000 characters)"
                  inputProps={{ maxLength: 1000 }}
                  sx={consistentTextStyle}
                />
              </MDBox>

              <MDBox mb={3}>
                <FormLabel component="legend" sx={{ fontWeight: "bold", color: "#000", mb: 1 }}>
                  6. If you are leaving for a new position, what makes it more attractive than the
                  present position?
                </FormLabel>
                <FormGroup>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.compensationAndBenefits}
                            onChange={(e) =>
                              handleInputChange("compensationAndBenefits", e.target.checked)
                            }
                            disabled={!formEditable}
                          />
                        }
                        label="Compensation and benefits"
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.opportunityForAdvancement}
                            onChange={(e) =>
                              handleInputChange("opportunityForAdvancement", e.target.checked)
                            }
                            disabled={!formEditable}
                          />
                        }
                        label="Opportunity for advancement & growth"
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.moreDesirableLocation}
                            onChange={(e) => handleInputChange("moreDesirableLocation", e.target.checked)}
                            disabled={!formEditable}
                          />
                        }
                        label="More desirable location"
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.moreResponsibility}
                            onChange={(e) =>
                              handleInputChange("moreResponsibility", e.target.checked)
                            }
                            disabled={!formEditable}
                          />
                        }
                        label="More responsibility"
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.opportunityForGoodProjects}
                            onChange={(e) =>
                              handleInputChange("opportunityForGoodProjects", e.target.checked)
                            }
                            disabled={!formEditable}
                          />
                        }
                        label="Opportunity to work on good projects"
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.workingForBigName}
                            onChange={(e) => handleInputChange("workingForBigName", e.target.checked)}
                            disabled={!formEditable}
                          />
                        }
                        label="Working for a Big Name in IT industry"
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.moreJobFlexibility}
                            onChange={(e) =>
                              handleInputChange("moreJobFlexibility", e.target.checked)
                            }
                            disabled={!formEditable}
                          />
                        }
                        label="More job flexibility"
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.showOtherText}
                            onChange={(e) => handleInputChange("showOtherText", e.target.checked)}
                            disabled={!formEditable}
                          />
                        }
                        label="Other (please specify)"
                      />
                    </Grid>
                    {formData.showOtherText && (
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          placeholder="Please specify... (10-1000 characters)"
                          value={formData.otherReasons}
                          onChange={(e) => handleInputChange("otherReasons", e.target.value)}
                          onBlur={() => handleBlur("otherReasons")}
                          variant="outlined"
                          size="small"
                          disabled={!formEditable}
                          error={!!errors.otherReasons}
                          helperText={errors.otherReasons || `${formData.otherReasons.length}/1000 characters`}
                          inputProps={{ maxLength: 1000 }}
                          sx={consistentTextStyle}
                        />
                      </Grid>
                    )}
                  </Grid>
                </FormGroup>
              </MDBox>

              {/* Questions 7-13 */}
              {[
                { field: 'suggestionsForPosition', question: '7. What suggestions do you have in terms of responsibilities,growth and future prospects associated with your position in BNT?' },
                { field: 'positionCompatibility', question: '8. Do you feel you were placed in a position compatible with your skills? If not, explain.' },
                { field: 'possibilityForAdvancement', question: '9. Do you feel that there was the possibility for advancement in your position? If not, what do you feel prevented advancement?' },
                { field: 'trainingDevelopmentNeeded', question: '10. Do you think you should have been offered more training/development within the position you held?' },
                { field: 'greatestChallenge', question: '11. What was the greatest challenge you faced in your position?' },
                { field: 'wouldRecommendBNT', question: '12. Would you recommend BNT to a friend as a good place to work?' },
                { field: 'suggestionsForImprovement', question: '13. Any suggestions for improvement?' }
              ].map(({ field, question }) => (
                <MDBox mb={3} key={field}>
                  <FormLabel component="legend" sx={{ fontWeight: "bold", color: "#000", mb: 1, "& .MuiFormLabel-asterisk": { color: "red" } }} required>
                    {question}
                  </FormLabel>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    value={formData[field]}
                    onChange={(e) => handleInputChange(field, e.target.value)}
                    onBlur={() => handleBlur(field)}
                    variant="outlined"
                    disabled={!formEditable}
                    error={!!errors[field]}
                    helperText={errors[field] || `${formData[field].length}/1000 characters`}
                    placeholder={`Please provide your answer (10-1000 characters)`}
                    inputProps={{ maxLength: 1000 }}
                    sx={consistentTextStyle}
                  />
                </MDBox>
              ))}

              <Divider sx={{ my: 3 }} />

              {/* Note Section */}
              <Paper elevation={0} sx={{ p: 2, mb: 3, bgcolor: "#fff3cd", border: "1px solid #ffc107" }}>
                <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1, textDecoration: "underline" }}>
                  Note:
                </Typography>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  In case you shall be closing your HDFC salary account please inform us. Your F&amp;F
                  will be done in the following month. You will be requested to visit BNT and
                  collect your F&amp;F cheque and sign the F&amp;F document.
                </Typography>
                <Typography variant="body2">
                  Please take your last 3 month&apos;s salary slip &amp; Form 16 before submitting your laptop.
                </Typography>
                <Typography variant="body2">
                  Kindly make a note of your Paysquare user ID, password &amp; email id or please regenerate password as you may require it post your exit.
                </Typography>
              </Paper>

              {/* Signature Section */}
              <Paper elevation={0} sx={{ p: 3, mb: 3, bgcolor: "#f5f5f5" }}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Date"
                        value={formData.interviewDate}
                        onChange={(newValue) => handleInputChange("interviewDate", newValue)}
                        onBlur={() => handleBlur("interviewDate")}
                        format="DD/MM/YYYY"
                        slotProps={{
                          textField: {
                            size: "small",
                            fullWidth: true,
                            error: !!errors.interviewDate,
                            helperText: errors.interviewDate,
                          }
                        }}
                        disabled={!formEditable}
                        readOnly
                        sx={{ maxWidth: '200px' }} // Add this line to control DatePicker width
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <SignatureUpload section="employee" label="Employee's Signature" />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <SignatureUpload section="interviewer" label="Interviewer's Signature" />
                  </Grid>
                </Grid>
              </Paper>

              {/* Action Buttons */}
              <MDBox mt={4} display="flex" justifyContent="flex-end" gap={2}>
                <MDBox display="flex" gap={2} alignItems="center">
                  {/* Close / Cancel Button */}
                  <MDButton
                    variant="outlined"
                    color="secondary"
                    onClick={() => isAdmin ? navigate("/exitInterviewList") : navigate("/resignation")}
                  >
                    {(!formEditable && !interviewerSignEditable) ? "Close" : "Cancel"}
                  </MDButton>

                  {/* Employee Buttons - Draft & Submit */}
                  {!isAdmin && formEditable && (
                    <>
                      <MDButton
                        variant="contained"
                        color="warning"
                        startIcon={<Save />}
                        onClick={handleSaveAsDraft}
                      >
                        Save as Draft
                      </MDButton>

                      <MDButton
                        type="submit"
                        variant="gradient"
                        color="info"
                        sx={{ background: properties.colors.bgcolorbluethem }}
                      >
                        Submit
                      </MDButton>
                    </>
                  )}

                  {/* Admin Button - Submit Interviewer Signature */}
                  {isAdmin && interviewerSignEditable && (
                    <MDButton
                      type="submit"
                      variant="gradient"
                      color="info"
                      sx={{ background: properties.colors.bgcolorbluethem }}
                    >
                      Submit Interviewer Signature
                    </MDButton>
                  )}

                  {/* Status Chips */}
                  {formStatus === "SUBMITTED_BY_EMPLOYEE" && !isAdmin && (
                    <Chip
                      label="Awaiting Interviewer Signature"
                      color="warning"
                      sx={{ height: 'auto', py: 1, px: 2 }}
                    />
                  )}
                  {formStatus === "SUBMITTED_BY_ADMIN" && (
                    <Chip
                      label="Form Completed - Read Only"
                      color="success"
                      sx={{ height: 'auto', py: 1, px: 2 }}
                    />
                  )}
                </MDBox>
              </MDBox>
            </form>
          </MDBox>
        </Card>
      </MDBox>

      {/* Confirmation Dialog */}
      <Dialog open={confirmDialogOpen} onClose={() => setConfirmDialogOpen(false)}>
        <DialogTitle>Confirm Submission</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {isAdmin ? (
              <>Are you sure you want to submit the interviewer signature?<br /><br />
                <strong>This will mark the exit interview as complete.</strong></>
            ) : (
              <>Are you sure you want to submit this Exit Interview Form?<br /><br />
                <strong>Once submitted, you will NOT be able to edit this form again.</strong></>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleFinalSubmit} variant="contained" color="primary" sx={{ color: '#fff' }} autoFocus>
            Yes, Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackOpen}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={snackColor === "success" ? "success" : "error"}
          variant="filled"
          sx={{ width: "100%", color: "#fff" }}
        >
          {snackMessage}
        </Alert>
      </Snackbar>
    </DashboardLayout>
  );
}